export default "<p>\r\n  parish-collection works!\r\n</p>\r\n"